import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import { CardsSection } from "@shared/uiNew/CardsSection"

import markerAnimation from "@shared/animations/animation_7.json"

import * as styles from "../styles.module.scss"

const CardsSectionChat = (props) => (
  <CardsSection
    title="Больше, "
    titleTail="чем просто виджет"
    description={<h4 className={styles.cardDesc}>Carrot quest – экосистема для вашего общения с клиентами</h4>}
    className={styles.cards}
    withBg={true}
    bgColor="#A7A7FF"
    markerVariant="topics"
    id="topics"
    markerAnimationData={markerAnimation}
    classNameMarker={styles.cardMarker}
    cardsLayout="centered_rows"
    items={widgetArray.map((item, i) => ({
      img: item.img,
      title: item.title,
      text: item.description,
      imageMode: "inline",
    }))}
  />
)

export default CardsSectionChat

const widgetArray = [
  {
    img: <StaticImage objectFit="contain" objectPosition="left" src="../assets/bullet_1.png" alt="Логотп мтс линк" width={106} placeholder="none" />,
    title: "Омниканальность",
    description:
      "Клиент начал диалог на сайте, а продолжил в Telegram? Вся история общения хранится в одной карточке — оператор видит контекст и не задает лишних вопросов.",
  },
  {
    img: <StaticImage objectFit="contain" objectPosition="left" src="../assets/bullet_2.png" alt="Логотп мтс линк" width={148} placeholder="none" />,
    title: "Квалификация и прогрев",
    description: "Лид-бот выявляет потребности клиента, а AI-бот отвечает на вопросы о продукте, пока менеджер готовится к связи.",
  },
  {
    img: <StaticImage objectFit="contain" objectPosition="left" src="../assets/bullet_3.png" alt="Логотп мтс линк" width={148} placeholder="none" />,
    title: "Бесшовная интеграция с CRM",
    description: "Все данные о диалогах и контакты лидов автоматически улетают в вашу CRM. Никакого ручного переноса и потерянных заявок.",
  },
  {
    img: <StaticImage objectFit="contain" objectPosition="left" src="../assets/bullet_4.png" alt="Логотп мтс линк" width={148} placeholder="none" />,
    title: "Гибкая кастомизация",
    description: "Настройте внешний вид чата, правила маршрутизации и стиль общения бота под ваш бренд самостоятельно, без привлечения разработчиков.",
  },
  {
    img: <StaticImage objectFit="contain" objectPosition="left" src="../assets/bullet_5.png" alt="Логотп мтс линк" width={148} placeholder="none" />,
    title: "Адаптирован под любые устройства",
    description:
      "Чат Carrot quest адаптирован под смартфоны — быстро открывается, не моргает, не исчезает при скролле. Клиент напишет в пару касаний — вы ответите мгновенно.",
  },
]
